import(/* webpackMode: "eager" */ "/app/apps/web/src/app/auth/login/page.tsx");
